<script lang="ts">
	import { Icon } from '@repo/commons/components'

	interface Props {
		labels?: string[]
		numberOfSteps: number
		currentStep: number
		allowNext?: boolean
		allowPrev?: boolean
		onChange?: (step: number) => void
		handleBeforeChange?: (step: number) => void
	}

	let {
		labels,
		numberOfSteps,
		currentStep = $bindable(0),
		allowNext = false,
		allowPrev = true,
		handleBeforeChange,
		onChange
	}: Props = $props()

	const steps = Array.from({ length: numberOfSteps }, (_, i) => i)

	const handleBack = () => {
		if (currentStep > 0) {
			const newValue = currentStep - 1

			if (handleBeforeChange) {
				handleBeforeChange(newValue)
				return
			}
			currentStep = newValue
		}
	}

	const handleForward = () => {
		if (currentStep < numberOfSteps - 1 && allowNext) {
			const newValue = currentStep + 1

			if (handleBeforeChange) {
				handleBeforeChange(newValue)
				return
			}

			currentStep += 1
		}
	}

	$effect(() => {
		if (currentStep) {
			onChange?.(currentStep)
		}
	})
</script>

<div class="container">
	<p class="step-indicator">
		Step {currentStep + 1} of {numberOfSteps}
		{labels?.[currentStep] ? ` - ${labels[currentStep]}` : ''}
	</p>
	<div class="stepper-wrapper">
		{#each steps as step}
			{@const hasPassed = step < currentStep + 1}
			<div class="stepper-item" class:active={hasPassed} />
		{/each}
	</div>
	<div class="actions">
		<button class="text-btn" disabled={currentStep === 0 || !allowPrev} onclick={handleBack}>
			<Icon name="arrowLeft" size="sm" />
			Back
		</button>
		<button
			class="text-btn"
			disabled={!allowNext || currentStep + 1 >= numberOfSteps}
			onclick={handleForward}
		>
			Forward
			<Icon name="arrowRight" size="sm" />
		</button>
	</div>
</div>

<style>
	.container {
		@apply flex flex-col gap-2 w-full min-w-[400px];
	}
	.stepper-wrapper {
		@apply flex gap-1;
	}
	.stepper-item {
		@apply w-full h-2 bg-[#00498011] rounded-md transition-colors duration-300;
	}
	.stepper-item.active {
		@apply bg-brand;
	}
	.step-indicator {
		@apply text-base font-semibold text-[#001626E5];
	}
	.actions {
		@apply flex gap-4 mt-2;
	}
	.text-btn {
		@apply flex items-center gap-2 text-base font-semibold text-brand bg-transparent border-0 p-0 m-0 cursor-pointer transition-colors duration-200;
	}
	.text-btn:disabled {
		@apply text-[#003A661A] cursor-not-allowed;
	}
</style>
